export default __webpack_public_path__ + "static/media/scrumU.39ce3fc1.webp";